import actionTypes from "./actionTypes";
import api from "./api";
export default {
    deleteDocument: (documentId, projectId) => ({
        type: actionTypes.DELETE_DOCUMENT,
        payload: {
            promise: () => api.deleteDocument(documentId)
        },
        scope: `${actionTypes.DELETE_DOCUMENT}_${documentId}`,
        meta: {
            documentId,
            projectId
        }
    })
};
